module.exports = __webpack_public_path__ + "img/home.2ed67517.jpg";